import * as React from 'react';
import { useSelector } from 'react-redux';
import { getIsBooked, getOrder } from '../../../store/order/selectors';
import PassengersToolbar from '../Form/PassengersToolbar/PassengersToolbar';
import Inner from './Inner/Inner';
import { ThemeProvider, useTheme } from '../../../../theme';
import Consents from '../../../../Consents';
import getOrderDataLayer from '../../../../DataLayerAnalytics/orderDataLayerInstance';
import WebskyServicesAnalytics from '../../../../DataLayerAnalytics/WebskyServicesAnalytics';
const ServicesAggregationPage = props => {
    const [segmentId, setSegmentId] = React.useState('0');
    const segmentIdRef = React.useRef(segmentId);
    const order = useSelector(getOrder);
    const isBooked = useSelector(getIsBooked);
    const nextSegmentScroll = React.useRef(false);
    const theme = useTheme('Checkout').ServicesAggregationPage;
    const [everyTravelCart, setEveryTravelCart] = React.useState(null);
    const [needToConfirmEveryTravelCart, setNeedToConfirmEveryTravelCart] = React.useState(false);
    const onScrollListener = () => {
        if (nextSegmentScroll.current && window.pageYOffset <= 0) {
            nextSegmentScroll.current = false;
            setTimeout(setNextSegment, 300);
        }
    };
    React.useEffect(() => {
        if (isBooked) {
            getOrderDataLayer().beginCheckout(WebskyServicesAnalytics.getCheckoutSelectedServices(order));
        }
    }, [isBooked]);
    React.useEffect(() => {
        window.addEventListener('scroll', onScrollListener);
        return () => {
            window.removeEventListener('scroll', onScrollListener);
        };
    });
    const changeSegmentWithSmooth = () => {
        if (window.pageYOffset > 0) {
            nextSegmentScroll.current = true;
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 0);
        }
        else {
            setNextSegment();
        }
    };
    const setNextSegment = () => {
        setSegmentId(segmentId => {
            if (+segmentId < order.flight.segments.length - 1) {
                return (+segmentId + 1).toString();
            }
            return segmentId;
        });
    };
    const onNextClickHandler = () => {
        var _a;
        const segmentIdInt = parseInt(segmentIdRef.current);
        if (segmentIdInt < order.flight.segments.length - 1) {
            changeSegmentWithSmooth();
        }
        else {
            if (!(everyTravelCart === null || everyTravelCart === void 0 ? void 0 : everyTravelCart.isOrdered) && ((_a = everyTravelCart === null || everyTravelCart === void 0 ? void 0 : everyTravelCart.items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setNeedToConfirmEveryTravelCart(true);
            }
            else {
                props.setNextStep();
            }
        }
    };
    React.useEffect(() => {
        segmentIdRef.current = segmentId;
    }, [segmentId]);
    React.useEffect(() => {
        var _a;
        if (needToConfirmEveryTravelCart && (everyTravelCart.isOrdered || !((_a = everyTravelCart === null || everyTravelCart === void 0 ? void 0 : everyTravelCart.items) === null || _a === void 0 ? void 0 : _a.length))) {
            setNeedToConfirmEveryTravelCart(false);
            props.setNextStep();
        }
    }, [everyTravelCart]);
    const aggregatorStyles = {
        ServiceSummary: {
            ServiceSummaryDivider: {
                container: theme.serviceSummaryDivider
            }
        },
        CheckoutAdditionalService: {
            AggregatorService: {
                container: theme.aggregatorService__container
            }
        }
    };
    return (React.createElement("div", null,
        React.createElement(ThemeProvider, { value: aggregatorStyles },
            React.createElement(Inner, { segmentId: segmentId, onNextSegment: onNextClickHandler, setSegmentId: setSegmentId, userInfo: props.userInfo, refetchUser: props.refetchUser, goToChangePassenger: props.goToChangePassenger, goToRefund: props.goToRefund, goToExchange: props.goToExchange, everyTravelStyles: props.everyTravelStyles, everyTravelSearchFormStyles: props.everyTravelSearchFormStyles, everyTravelCart: everyTravelCart, setEveryTravelCart: setEveryTravelCart, needToConfirmCart: needToConfirmEveryTravelCart })),
        React.createElement(Consents, null, ({ onConfirm }) => (React.createElement(PassengersToolbar, { currentStep: props.currentStep, onNextClick: onNextClickHandler, setNextStep: onNextClickHandler, onConfirmConsents: onConfirm })))));
};
export default ServicesAggregationPage;
